import { PaletteResponse } from "pages/media/types/";
import { colorKeys } from "../..";
import { ColorPickerCard } from "./ColorPickerCard";
import { Col, Flex, FormInstance, Row } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { PreviewTitle } from "./PreviewTitle";
import { useTranslate } from "#src/hooks";

export const ColorsCard = ({
  form,
  setColors,
  palette,
}: {
  form: FormInstance;
  setColors: React.Dispatch<React.SetStateAction<Partial<PaletteResponse>>>;
  palette: PaletteResponse;
}) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  return (
    <Flex vertical gap={20}>
      <PreviewTitle title={t("media.brandkit.edit.colors")} />
      <Row gutter={[30, 30]}>
        {colorKeys.map((colorKey) => {
          const isPrimary = colorKey === "primary_color";
          const value = palette[colorKey];
          return (
            <Col key={colorKey} xs={24} xl={12}>
              <ColorPickerCard
                allowClear={!isPrimary}
                colorKey={colorKey}
                form={form}
                required={isPrimary}
                value={value}
                setColors={setColors}
                style={{
                  height: 42,
                  background: theme.colorWhite,
                  border: `1px solid ${theme.colorLightGrey}`,
                }}
              />
            </Col>
          );
        })}
      </Row>
    </Flex>
  );
};
